// AI秘書ウィジェット。AppLayout に1行マウントする唯一の接点。
// 課金OFF or 未ログインなら何も描画しない（本体業務を一切妨げない）。
import { useState } from 'react';
import { useAuth } from '@modules/auth';
import { IS_ENABLED } from '../config';
import { SecretaryPanel } from './SecretaryPanel';
import airsIcon from '../assets/airs-icon.png';

export function SecretaryWidget() {
  const { isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  if (!IS_ENABLED || !isAuthenticated) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {isOpen ? (
        <SecretaryPanel onClose={() => setIsOpen(false)} />
      ) : (
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          aria-label="AI秘書を開く"
          className="h-14 w-14 overflow-hidden rounded-full shadow-lg transition hover:scale-105"
        >
          {/* アイコンは円形にデザイン済みなので、丸ボタンいっぱいに表示する */}
          <img src={airsIcon} alt="" className="h-full w-full object-cover" />
        </button>
      )}
    </div>
  );
}
